<div class="participantOverview" [class.compact]="compact()">
	<!--MAIN INFO PANE-->
	<div class="mandatoryInfo">
		<i
			[ngClass]="{
				'fa-user-graduate': participant().participantType === ParticipantType.Learner,
				'fa-user-md': participant().participantType === ParticipantType.Instructor,
				'fa-user-injured': participant().participantType === ParticipantType.StandardizedPatient,
			}"
			class="fad typeIcon"
		>
		</i>
		<span class="studentName">
			{{ participant().user.fullname }}
		</span>

		@if (participant().user.email) {
			<label class="chipLabel">
				{{ participant().user.email }}
			</label>
		}
	</div>

	<!--DETAIL INFO LIST-->
	@if (!showNameOnly()) {
		<div class="horizontalList">
			<div>
				<label>{{ T.LABEL_STUDENT_ID | translate }}</label>
				<span>{{ participant().user.isicNumber ?? T.LABEL_NOT_PROVIDED | translate }}</span>
			</div>
			<div>
				<label>{{ T.LABEL_BIRTHDATE | translate }}</label>
				<span>
					{{
						!!participant().user.birthday
							? (participant().user.birthday | date: (T.DATE_FORMAT_LONG_DAY | translate) : "" : translate.currentLang)
							: (T.LABEL_NOT_PROVIDED | translate)
					}}
				</span>
			</div>
			<div>
				<label>{{ T.LABEL_GENDER | translate }}</label>
				<span>
					@if (!participant().user.gender) {
						{{ T.LABEL_NOT_PROVIDED | translate }}
					} @else {
						<i
							[ngClass]="{
								'fa-mars': participant().user.gender === Gender.Male,
								'fa-venus': participant().user.gender === Gender.Female,
								'fa-genderless': participant().user.gender === Gender.Other,
							}"
							class="far"
						>
						</i>
						{{ participant().user.gender | enumLabel: EnumLabel.Gender }}
					}
				</span>
			</div>
		</div>
	}

	<ng-content select="[additionalContent]" />
</div>
